import type {
  SavedListOutreachChannelDTO,
  SavedListOutreachStatusDTO,
  SavedListOutreachStatusItemDTO,
} from '@/entities/saved-creators-list';

export const SAVED_LIST_OUTREACH_CHANNELS: SavedListOutreachChannelDTO[] = [
  'email',
  'tiktok_dm',
];

export const SAVED_LIST_OUTREACH_STATUS_OPTIONS: SavedListOutreachStatusDTO[] = [
  'not_contacted',
  'queued',
  'sent',
  'replied',
  'interested',
  'confirmed',
  'declined',
];

export const SAVED_LIST_OUTREACH_CHANNEL_LABELS: Record<SavedListOutreachChannelDTO, string> = {
  email: 'Email',
  tiktok_dm: 'TikTok DM',
};

export const SAVED_LIST_OUTREACH_STATUS_LABELS: Record<SavedListOutreachStatusDTO, string> = {
  not_contacted: 'Not contacted',
  queued: 'Queued',
  sent: 'Sent',
  replied: 'Replied',
  interested: 'Interested',
  confirmed: 'Confirmed',
  declined: 'Declined',
};

export type SavedListOutreachStage = 'not_contacted' | 'sent' | 'confirmed' | 'declined';

export const SAVED_LIST_OUTREACH_STAGE_OPTIONS: SavedListOutreachStage[] = [
  'not_contacted',
  'sent',
  'confirmed',
  'declined',
];

export const SAVED_LIST_OUTREACH_STAGE_LABELS: Record<SavedListOutreachStage, string> = {
  not_contacted: 'Not contacted',
  sent: 'Sent',
  confirmed: 'Confirmed',
  declined: 'Declined',
};

export function getSavedListOutreachStatus(
  statuses: SavedListOutreachStatusItemDTO[],
  creatorId: string,
  channel: SavedListOutreachChannelDTO,
): SavedListOutreachStatusDTO {
  return (
    statuses.find((item) => item.creator_id === creatorId && item.channel === channel)?.status ??
    'not_contacted'
  );
}

export function getSavedListCreatorOutreachStage(
  statuses: SavedListOutreachStatusItemDTO[],
  creatorId: string,
): SavedListOutreachStage {
  const channelStatuses = SAVED_LIST_OUTREACH_CHANNELS.map((channel) =>
    getSavedListOutreachStatus(statuses, creatorId, channel),
  );

  if (channelStatuses.some((status) => status === 'confirmed')) {
    return 'confirmed';
  }

  if (channelStatuses.some((status) => status === 'declined')) {
    return 'declined';
  }

  if (channelStatuses.every((status) => status === 'not_contacted')) {
    return 'not_contacted';
  }

  return 'sent';
}

export function isSavedListCreatorConfirmed(
  statuses: SavedListOutreachStatusItemDTO[],
  creatorId: string,
) {
  return getSavedListCreatorOutreachStage(statuses, creatorId) === 'confirmed';
}

export function getConfirmedSavedListCreatorIds(
  statuses: SavedListOutreachStatusItemDTO[],
  creatorIds: string[],
) {
  return creatorIds.filter((creatorId) => isSavedListCreatorConfirmed(statuses, creatorId));
}
